module.exports = __webpack_public_path__ + "img/17.ab1f8995.jpg";